import { createAction, props } from '@ngrx/store';
import { ContactResponseModel } from '../model/contact-response.model';
import { ContactModel } from '../model/contact.model';

export const CONTACT = '[Contact Page] Contact';
export const CONTACT_RESET = '[Contact Page] Reset Contact';
export const CONTACT_SUCCESS = '[Contact Page] Contact Success';
export const CONTACT_FAILURE = '[Contact Page] Contact Failure';

export const contact = createAction(
    CONTACT,
    props<ContactModel>()
)

export const contactReset = createAction(
    CONTACT_RESET
)

export const contactSuccess = createAction(
    CONTACT_SUCCESS,
    props<ContactResponseModel>()
)

export const contactFailure = createAction(
    CONTACT_FAILURE,
    props<ContactResponseModel>()
)
